import DeleteIcon from "@mui/icons-material/Delete";
import { Alert, AlertTitle, Typography } from "@mui/material";
import { FileField, FileInput, LinearProgress, SimpleForm, useCreate, useNotify, useRedirect } from "react-admin";
import { FieldValues, useFormContext } from "react-hook-form";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";
import { useGroupCertificationModalContext } from "../hooks/useGroupCertifModal";
import { SiteContryEnum } from "shared/enums/globalEnums";

const UploadJsonForm = () => {
  const [create, { isLoading }] = useCreate();
  const notify = useNotify();
  const redirect = useRedirect();
  const { openModalAndWait } = useGroupCertificationModalContext();

  const handleSubmit = (data: FieldValues) => {
    try {
      create(
        SiteResourcesEnum.SiteUpload,
        {
          data,
          meta: {
            multipart: true,
          },
        },
        {
          onSuccess: async (data) => {
            notify("Upload success", { type: "success" });
            if (data.country === SiteContryEnum.Finland) {
              await openModalAndWait(data.id, data.start_date);
            }
            redirect("list", SiteResourcesEnum.Sites);
          },
          onError: (error) => {
            notify("ERROR : " + (error as any).body?.detail, { type: "error" });
          },
        },
      );
    } catch (error) {
      notify("Upload error: " + (error as Error).message, { type: "error" });
    }
  };
  return (
    <SimpleForm onSubmit={handleSubmit}>
      <Alert severity="info" sx={{ width: "100%" }}>
        <AlertTitle sx={{ fontWeight: "bold" }}>Information</AlertTitle>
        <Typography variant="body1">The uploaded file must be a valid JSON file.</Typography>
        <Typography variant="body1">
          The uploaded file will not be linked to groups, even if the json file contains groups.
        </Typography>
        <Typography variant="body1">You will need to link the sites to the groups manually.</Typography>
      </Alert>
      {isLoading ? <LinearProgress /> : <FormContent />}
    </SimpleForm>
  );
};

export default UploadJsonForm;

const FormContent = () => {
  const { watch } = useFormContext();
  const file = watch("file");
  return (
    <FileInput
      source="file"
      accept={{ "application/json": [".json"] }}
      removeIcon={DeleteIcon}
      placeholder={
        <Typography variant="body1" color="primary.main" fontWeight={"bold"}>
          Drag and drop your JSON file here or click to browse
        </Typography>
      }
      sx={{
        "& .RaLabeled-label": {
          display: "none",
        },
        "& .RaFileInput-dropZone": {
          borderRadius: "10px",
          border: "3px dashed gainsboro",
          py: 6,
          mt: 3,
          cursor: "pointer",
          display: file ? "none" : "block",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.05)",
          },
        },
        "& .RaFileInput-removeButton": {
          borderRadius: "10px",
          border: "3px dashed gainsboro",
          py: "44px",
          textAlign: "center",
          mb: 3,
          "& a": {
            fontWeight: "bold",
            color: "primary.main",
            fontSize: 16,
          },
        },
      }}
    >
      <FileField source="src" title="title" />
    </FileInput>
  );
};
